import { getFrontendOrigin } from "./frontendOrigin";

/**
 * Admin hand-off: pass SPA origin so Bidhom can forward it to the API for emails.
 */
export function buildAdminLoginUrl(accessToken) {
    const adminBase = (process.env.REACT_APP_ADMIN_URL || "").replace(/\/?$/, "");
    const params = new URLSearchParams({
        token: accessToken,
        origin: getFrontendOrigin(),
    });
    return `${adminBase}/admin/admin-login/?${params.toString()}`;
}
